import React, {ReactNode, SetStateAction, useEffect, useRef} from "react";
import ReactDom from "react-dom";
import CloseIcon from "@mui/icons-material/Close";

type ModalPropsType = {
  children: ReactNode;
  open: boolean;
  className?: string;
  contentClassName?: string;
  setOpen?: React.Dispatch<SetStateAction<boolean>> | ((show: boolean) => void);
};

export default function ModalV2({
                                children,
                                open,
                                className,
                                contentClassName,
                                setOpen,
                              }: ModalPropsType) {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const body = document.body;
    const original = body.style.overflow;
    body.style.overflow = "hidden";
    return () => { body.style.overflow = original; };
  }, [open]);
  // useOnClickOutside(modalRef, () => (setOpen ? setOpen!(false) : null));
  if (!open) return null;

  return ReactDom.createPortal(
      <div
          onClick={() => setOpen && setOpen(false)}
          className={`${
              open ? "fixed" : null
          } top-0 left-0 h-full w-full flex items-center justify-center bg-black bg-opacity-50 ${className}`}
          style={{zIndex: 100}}
      >

        <div className={`bg-white shadow-md p-4 flex flex-col gap-4 rounded-md relative ${contentClassName ?? "w-[80vw]"}`}
             onClick={(e) => {
               e.stopPropagation();
             }}
             ref={modalRef}
        >
            <button className="absolute right-2 top-2 cursor-pointer"  onClick={() => setOpen && setOpen(false)}>
                <CloseIcon/>
            </button>
          {children}
        </div>
      </div>,
      document.getElementById("portal")!
  );
}
